<div class="dropdownBtn {{layoutModifier}}" [ngClass]="{
  'dropdownBtn_open': isOpen && !disabled,
  'dropdownBtn_disabled': disabled
}">
  <div class="dropdownBtn-wrapper" (mouseleave)="onDropdownLeave()">
    <div type="button" class="dropdownBtn-action" (click)="toggleMenu($event)">
      <div *ngIf="layoutMod === 'label' || layoutMod === 'form'" class="h5">{{ buttonText | translate }}</div>
      <div *ngIf="layoutMod === 'form_sm'" class="h6">{{ buttonText | translate }}</div>
      <i *ngIf="layoutMod !== 'label'" svgIcon [icon]="icon" [ngClass]="{
      '_open': isOpen,
      '_disabled': disabled
      }"></i>
    </div>
    <div class="dropdownBtn-listWrapper">
      <ul class="dropdownBtn-list">
        <li *ngFor="let item of items">
          <a class="dropdownBtn-item" [ngClass]="{'dropdownBtn-item_icon': item.icon}" (click)="onItemSelected($event, item)">
            <i *ngIf="item.icon" svgIcon [icon]="item.icon"  [iconSize]="svgIconSizeMod.MEDIUM" class="dropdownBtn-itemIcon"></i>
            {{ item.title | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
